import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

function Section({ title, children }) {
  return (
    <div style={{ marginBottom: '36px' }}>
      <h2 style={{
        fontFamily: "'Syne', sans-serif",
        fontSize: '20px', fontWeight: 700, color: '#0f172a',
        letterSpacing: '-0.01em', marginBottom: '12px',
        paddingBottom: '10px', borderBottom: '1px solid #f1f5f9',
      }}>{title}</h2>
      <div style={{ fontSize: '15px', color: '#475569', lineHeight: 1.8 }}>{children}</div>
    </div>
  );
}

export default function TermsOfService() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Syne:wght@600;700;800&display=swap');
        *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
        body { background: #f8fafc; -webkit-text-size-adjust: 100%; }
        a { color: #3b82f6; text-decoration: none; }
        a:hover { text-decoration: underline; }
      `}</style>

      {/* Top navbar */}
      <div style={{
        position: 'sticky', top: 0, zIndex: 100,
        background: 'rgba(255,255,255,0.92)', backdropFilter: 'blur(12px)',
        borderBottom: '1px solid #f1f5f9',
        padding: '14px 24px',
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      }}>
        <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: '10px', textDecoration: 'none' }}>
          <div style={{ width: '32px', height: '32px', borderRadius: '8px', background: 'linear-gradient(135deg,#3b82f6,#1d4ed8)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '16px' }}>📦</div>
          <span style={{ fontFamily: "'Syne',sans-serif", fontSize: '17px', fontWeight: 700, color: '#0f172a' }}>StockSpace</span>
        </Link>
        <Link to="/" style={{ fontSize: '14px', color: '#64748b', fontWeight: 500 }}>← Back to home</Link>
      </div>

      {/* Hero */}
      <div style={{
        background: 'linear-gradient(135deg, #1a1040 0%, #2e1065 50%, #4c1d95 100%)',
        padding: '56px 24px 48px',
        textAlign: 'center',
      }}>
        <div style={{ display: 'inline-block', fontSize: '11px', fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase', color: '#a78bfa', background: 'rgba(167,139,250,0.15)', border: '1px solid rgba(167,139,250,0.3)', borderRadius: '6px', padding: '4px 12px', marginBottom: '16px' }}>Legal</div>
        <h1 style={{ fontFamily: "'Syne',sans-serif", fontSize: '36px', fontWeight: 800, color: '#ffffff', letterSpacing: '-0.02em', marginBottom: '10px' }}>Terms of Service</h1>
        <p style={{ fontSize: '15px', color: '#c4b5fd' }}>Last updated: June 2025 &nbsp;·&nbsp; Effective: June 2025</p>
      </div>

      {/* Content */}
      <div style={{ maxWidth: '760px', margin: '0 auto', padding: '48px 24px 80px' }}>

        <div style={{ background: '#faf5ff', border: '1px solid #e9d5ff', borderRadius: '12px', padding: '16px 20px', marginBottom: '36px', fontSize: '14px', color: '#6b21a8', lineHeight: 1.6 }}>
          <strong>Summary:</strong> StockSpace is a free inventory management tool. By using it, you agree to use it lawfully and not to misuse or attempt to harm the service. We provide it as-is and are not liable for business losses. You own your data.
        </div>

        <Section title="1. Acceptance of Terms">
          <p>By accessing or using StockSpace ("the Service"), you agree to be bound by these Terms of Service ("Terms"). If you do not agree, do not use the Service. These Terms apply to all users including organisation admins, managers, and staff members.</p>
        </Section>

        <Section title="2. Description of Service">
          <p style={{ marginBottom: '12px' }}>StockSpace is a free, cloud-based inventory management application that allows businesses to track stock, manage transactions, analyse sales data, and collaborate with team members.</p>
          <p>The Service is provided free of charge. We reserve the right to introduce paid features in the future, but any currently free features will remain accessible with adequate notice of any changes.</p>
        </Section>

        <Section title="3. Account Registration">
          <ul style={{ paddingLeft: '20px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
            <li>You must provide accurate and complete information when creating an account.</li>
            <li>You are responsible for maintaining the confidentiality of your account credentials.</li>
            <li>You are responsible for all activity that occurs under your account.</li>
            <li>You must be at least 13 years of age to use the Service.</li>
            <li>One person or entity may not maintain more than one free account unless explicitly permitted.</li>
          </ul>
        </Section>

        <Section title="4. Acceptable Use">
          <p style={{ marginBottom: '12px' }}>You agree to use StockSpace only for lawful business purposes. You must not:</p>
          <ul style={{ paddingLeft: '20px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
            <li>Use the Service for any illegal activity or in violation of any applicable Indian or international law</li>
            <li>Attempt to gain unauthorised access to any part of the Service or other users' data</li>
            <li>Reverse engineer, decompile, or attempt to extract the source code of the Service</li>
            <li>Use automated scripts, bots, or scrapers to access the Service</li>
            <li>Upload malicious code, viruses, or any content that could harm the Service or other users</li>
            <li>Impersonate another person or organisation</li>
            <li>Use the Service to store or transmit unlawful, offensive, or harmful content</li>
          </ul>
        </Section>

        <Section title="5. Your Data and Content">
          <p style={{ marginBottom: '12px' }}>You retain full ownership of all data and content you enter into StockSpace, including product information, transaction records, and organisation details.</p>
          <p style={{ marginBottom: '12px' }}>By using the Service, you grant StockSpace a limited, non-exclusive licence to store, process, and display your data solely for the purpose of providing the Service to you.</p>
          <p>We do not claim ownership of your data, sell it, or use it for any purpose other than operating the Service.</p>
        </Section>

        <Section title="6. Organisation Admins">
          <p style={{ marginBottom: '12px' }}>If you create an organisation on StockSpace, you are the Organisation Admin and are responsible for:</p>
          <ul style={{ paddingLeft: '20px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
            <li>Managing access and permissions for team members you invite</li>
            <li>Ensuring all members of your organisation comply with these Terms</li>
            <li>The accuracy of data entered by your team</li>
          </ul>
        </Section>

        <Section title="7. Service Availability">
          <p style={{ marginBottom: '12px' }}>We strive to keep StockSpace available at all times but do not guarantee uninterrupted access. The Service may be unavailable due to maintenance, Firebase infrastructure issues, or other circumstances beyond our control.</p>
          <p>We will make reasonable efforts to notify users of planned downtime via email where possible.</p>
        </Section>

        <Section title="8. Disclaimer of Warranties">
          <p style={{ marginBottom: '12px' }}>StockSpace is provided <strong>"as is"</strong> and <strong>"as available"</strong> without warranties of any kind, either express or implied, including but not limited to warranties of merchantability, fitness for a particular purpose, or non-infringement.</p>
          <p>We do not warrant that the Service will be error-free, that defects will be corrected, or that the Service is free of viruses or other harmful components.</p>
        </Section>

        <Section title="9. Limitation of Liability">
          <p style={{ marginBottom: '12px' }}>To the fullest extent permitted by law, StockSpace and its operators shall not be liable for any indirect, incidental, special, consequential, or punitive damages, including but not limited to:</p>
          <ul style={{ paddingLeft: '20px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
            <li>Loss of profits or revenue</li>
            <li>Loss of data or business information</li>
            <li>Business interruption</li>
            <li>Any other commercial damages or losses</li>
          </ul>
          <p style={{ marginTop: '12px' }}>This limitation applies even if we have been advised of the possibility of such damages. Since StockSpace is a free service, our total liability to you for any claim shall not exceed ₹0 (zero rupees).</p>
        </Section>

        <Section title="10. Termination">
          <p style={{ marginBottom: '12px' }}>You may stop using the Service at any time. You may request deletion of your account and data by emailing <a href="mailto:stockspacesupport@gmail.com">stockspacesupport@gmail.com</a>.</p>
          <p>We reserve the right to suspend or terminate accounts that violate these Terms, engage in abusive behaviour, or misuse the Service, with or without prior notice depending on the severity of the violation.</p>
        </Section>

        <Section title="11. Changes to Terms">
          <p>We may update these Terms from time to time. We will notify you of significant changes by email or by prominently displaying a notice in the app. Continued use of the Service after changes take effect constitutes your acceptance of the revised Terms.</p>
        </Section>

        <Section title="12. Governing Law">
          <p>These Terms are governed by and construed in accordance with the laws of India, including the Information Technology Act, 2000 and the Digital Personal Data Protection Act, 2023. Any disputes shall be subject to the exclusive jurisdiction of the courts of India.</p>
        </Section>

        <Section title="13. Contact Us">
          <p>If you have questions about these Terms, please contact us:</p>
          <div style={{ background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '12px', padding: '16px 20px', marginTop: '12px' }}>
            <p><strong>StockSpace</strong></p>
            <p>Email: <a href="mailto:stockspacesupport@gmail.com">stockspacesupport@gmail.com</a></p>
            <p>GitHub: <a href="https://github.com/KavyaSingla244" target="_blank" rel="noreferrer">github.com/KavyaSingla244</a></p>
          </div>
        </Section>

        <div style={{ borderTop: '1px solid #f1f5f9', paddingTop: '24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '12px' }}>
          <Link to="/privacy" style={{ fontSize: '14px', color: '#3b82f6', fontWeight: 500 }}>← Privacy Policy</Link>
          <Link to="/" style={{ fontSize: '14px', color: '#3b82f6', fontWeight: 500 }}>Back to StockSpace →</Link>
        </div>
      </div>
    </>
  );
}